
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    icon: {
      type: String,
      default: "pi pi-question-circle",
    },
    iconColor: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "Lorem ipsum",
    },
    to: {
      type: String,
      default: null,
    },
    href: {
      type: String,
      default: null,
    },
  },
  data: () => ({}),
});
